// Import polyfills
import './shims/buffer.js';
import './shims/process.js';

// Explicitly add Buffer to global object
import { Buffer } from 'buffer';

// Make Buffer available globally
if (typeof window !== 'undefined') {
    window.Buffer = Buffer;
}

// This file intentionally doesn't export anything
// It's meant to be imported at the entry point of the application 